export const ACTIONS = {
  SET_CUE_ANALYTICS_DATA: 'SET_CUE_ANALYTICS_DATA',
  USER_IDENTIFICATION_CUE_ANALYTICS: 'USER_IDENTIFICATION',
};

export const setCueAnalyticsData = data => dispatch => {
  dispatch({
    type: ACTIONS.SET_CUE_ANALYTICS_DATA,
    payload: {
      data: {
        ...data,
        url: window.location.href,
        route: window.location.pathname,
      },
      timestamp: Number(new Date()),
    },
  });
};
